import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/",
    name: "index",
    meta: { title: "选好位" },
    component: () => import("../views/index.vue"),
  },
  {
    path: "/webView",
    name: "webView",
    meta: { title: "选好位" },
    component: () => import("../views/webView.vue"),
  },

  //模型
  {
    path: "/icon",
    name: "icon",
    meta: { title: "自定义图标" },
    component: () => import("../views/Icon.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  next();
});

export default router;
